
export default {
    methods: {
        showNotification: function (type, msg) {
            var widgetClass;
            var widgetText;
            switch (type) {
                case 'success':
                    widgetText = msg;
                    widgetClass = 'success';
                    break;
                case 'warning':
                    widgetText = msg;
                    widgetClass = 'warn';
                    break;
                case 'error':
                    widgetText = msg;
                    widgetClass = 'error';
                    break;
            }
            this.$notify({
                group: 'prolib-simple-top-left-notification',
                text: widgetText,
                type: widgetClass,
            });
        },
        showRequestErrorNotification: function () {
            this.$notify({
                group: 'prolib-simple-top-left-notification',
                text: this.$lang('Wystąpił błąd'),
                type: 'error',
            });
        }
    },
};
